export default {
  noDataRow: {
    textAlign: 'center',
    color: 'lightgrey',
    fontSize: 24,
  },
  noData: {
    fontSize: 250,
    color: 'lightgrey',
  },
  itemTypeCol: {
    width: 120,
  },
  exceptionTypeCol: {
    width: 120,
  },
  stageCol: {
    width: 130,
  },
  dateCol: {
    width: 180,
  },
};



// WEBPACK FOOTER //
// ./src/components/Reports/Exceptions/styles.js